var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c("div", { staticClass: "w-full" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm.$userIsAdmin
          ? _c("div", { staticClass: "form-item__row" }, [
              _c(
                "div",
                { staticClass: "form-item__field form-item__field--full" },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Targeting Tags"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-control",
                        staticStyle: { height: "auto", border: "none" },
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-xs-6" },
                            [
                              _c("h3", [_vm._v("Target")]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: { type: "description" },
                                model: {
                                  value: _vm.booking.target_tags,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.booking, "target_tags", $$v)
                                  },
                                  expression: "booking.target_tags",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-xs-6" },
                            [
                              _c("h3", [_vm._v("Restrict")]),
                              _vm._v(" "),
                              _c("tags", {
                                attrs: { type: "description" },
                                model: {
                                  value: _vm.booking.restrict_tags,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.booking, "restrict_tags", $$v)
                                  },
                                  expression: "booking.restrict_tags",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("h3", { staticClass: "col-xs-12" }, [
                            _vm._v("Gender"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-3" }, [
                            _c("div", { staticClass: "radio radio-primary" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.booking.gender,
                                    expression: "booking.gender",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "profile_visibility",
                                  id: "gender_both",
                                },
                                domProps: {
                                  value: null,
                                  checked: _vm._q(_vm.booking.gender, null),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(_vm.booking, "gender", null)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "gender_both" } }, [
                                _vm._v(
                                  "\n                  All\n                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-3" }, [
                            _c("div", { staticClass: "radio radio-primary" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.booking.gender,
                                    expression: "booking.gender",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "profile_visibility",
                                  id: "gender_male",
                                  value: "male",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.booking.gender, "male"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.booking,
                                      "gender",
                                      "male"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "gender_male" } }, [
                                _vm._v(
                                  "\n                  Male\n                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-3" }, [
                            _c("div", { staticClass: "radio radio-primary" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.booking.gender,
                                    expression: "booking.gender",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "profile_visibility",
                                  id: "gender_female",
                                  value: "female",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.booking.gender, "female"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.booking,
                                      "gender",
                                      "female"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "gender_female" } }, [
                                _vm._v(
                                  "\n                  Female\n                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-3" }, [
                            _c("div", { staticClass: "radio radio-primary" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.booking.gender,
                                    expression: "booking.gender",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  name: "profile_visibility",
                                  id: "gender_other",
                                  value: "other",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.booking.gender, "other"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.booking,
                                      "gender",
                                      "other"
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "gender_other" } }, [
                                _vm._v(
                                  "\n                  Other\n                "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-xs-12" },
                            [
                              _c("h3", [
                                _vm._v(
                                  "# " +
                                    _vm._s(
                                      _vm._f("sentenceCase")(
                                        _vm.$starLabelPlural
                                      )
                                    ) +
                                    " Targeted"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("h3", {
                                domProps: {
                                  textContent: _vm._s(_vm.talentAvailable),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "ladda-button",
                                {
                                  staticClass:
                                    "btn btn-sm btn-primary pull-right",
                                  attrs: {
                                    click: _vm.handleUpdateBookingTagsCallback,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Save\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin && !_vm.$vlastMode
          ? _c("div", { staticClass: "form-item__row" }, [
              _c(
                "div",
                { staticClass: "form-item__field form-item__field--full" },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v("Description Tags"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-control",
                        staticStyle: { height: "auto", border: "none" },
                      },
                      [
                        _c("tags", {
                          attrs: { type: "description" },
                          model: {
                            value: _vm.booking.description_tags,
                            callback: function ($$v) {
                              _vm.$set(_vm.booking, "description_tags", $$v)
                            },
                            expression: "booking.description_tags",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "ladda-button",
                          {
                            staticClass: "btn btn-sm btn-primary pull-right",
                            attrs: {
                              click:
                                _vm.handleUpdateBookingDescriptionTagsCallback,
                            },
                          },
                          [_vm._v("\n          Save\n        ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-full" }, [
      _c("h2", [_vm._v("Detailed Targeting")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }